import React from 'react'
import NavBar from '../../components/NavBar'
import Footer from '../../components/Footer'
import { Link } from 'react-router-dom'
import Faq from '../../components/Faq';
import Meta from '../../components/Meta';
import বিশালমূল্যছাড় from '../../assets/images/বিশাল-মূল্যছাড়.png'
import BSTIPermissionImg from '../../assets/images/BSTI-permission.png'
import compnayFormationImg from "../../assets/images/Company-Formation.jpg"
import onePersionCompanyImg from "../../assets/images/One-man-Company-e1605617207411.png"
import societyRegistrationIMg from "../../assets/images/Society-Registration.png"
import partnershipImg from "../../assets/images/Partnership-.png"
import rjscImg from "../../assets/images/RJSC-Filling.png"
import loanImg from "../../assets/images/Bank-loan.png"
import imprortImg from "../../assets/images/Import-Registration.png"
import exportImg from "../../assets/images/Export-Inmport-New.jpg"
import tradeImg from "../../assets/images/Trade-license-Registration.png"
import projectImg from "../../assets/images/Project-Profile-1.jpg"
import uddoktaImg from "../../assets/images/বিশাল-মূল্যছাড়.png"
import Marquee from 'react-fast-marquee';
import MarqueeCard from '../../components/MarqueeCard'

function UddoktaPackage() {
    const faqItems = [
        {
            title: 'What is a startup plan?',
            content: <strong>A startup business plan is a written document that outlines your ideas and strategies for
                launching, managing, and eventually exiting your new venture.</strong>
        },
        {
            title: 'What is start up model?',
            content: <strong>Your startup business model essentially explains how your business will operate and make
                money—and it also takes into account the cost structure.</strong>
        },
        {
            title: 'How do I create a startup plan?',
            content: <strong>A Step by Step Guide to Creating an Effective Startup Project...
                Define your project. As a startup, you need to have a clear and concise project plan</strong>
        }
    ];
    return (
        <>
            <Meta title="Uddokta Package"
                description="This page provides information about BSTI permission and related processes."
                image={uddoktaImg}
                keywords="keyword1, keyword2, keyword3"
            />
            
            <NavBar />

            <div className="container-fluid hero-header bg-light py-5 ">
                <div className="container py-5">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6">
                            <h1 className="display-4 mb-3 animated slideInDown">Startup Packages</h1>
                            <nav aria-label="breadcrumb animated slideInDown">
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="#">Startup</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Startup Packages</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-lg-6 animated fadeIn">
                            <img className="img-fluid animated pulse infinite" style={{ animationDuration: '3s' }} src={বিশালমূল্যছাড়} alt='বিশাল-মূল্যছাড়' />
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-xxl py-0">
                <div className="container">
                    <p>
                        “JK Associates”  one of the best Consultancy Firm in Bangladesh is here with a new Exciting
                        Startup Packages in an Exclusive and Budget-Friendly Consultancy fee with Many Packages for
                        the new Entrepreneurs. To start a new Business what you should do first and what step should
                        you take we will guide you from A to Z of your Business Plans.<br /><br />
                        We are capable to give you Every Support you want as a startup.  We Can help you with Limited
                        company formation packages, VAT, Tax, TIN, BIN,  Copyright, Trademark, Trade License, Import
                        License, Export License, Website Development, Logo Design and other Legal Support To your New
                        Company.<br /><br />
                        So Enroll on our Startup Package Now, and take your business to a Next Level.
                    </p>
                    <p className="color-text fs-5 mb-4">
                        <b>In the Basic Package, You will Get: 39,999 TK</b><br />
                        <b className='px-5'>*EMI Facilities</b>
                    </p>
                    <p>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Business Consultation
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Document Preparation
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Limited Company Registration (10 Lac Authorized Capital)
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Company TIN Registration
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Trade License (Up to 5 Lac Paid-up)
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Bank Account Opening Assistance
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Company Stamp
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                All government fees are included with this package
                            </span>
                        </div>
                    </p>

                    <p className="color-text fs-5 mb-4">
                        <b>In the Basic Package, You will Get: 88,999 TK</b><br />
                        <b className='px-5'>*EMI Facilities</b>
                    </p>
                    <p>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Business Consultation
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Document Preparation
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Limited Company Registration (40 Lac Authorized Capital)
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Company TIN Registration
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Trade License (Up to 10 Lac Paid-up)
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Bank Account Opening Assistance
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Company Stamp
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                BIN Registration
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Trademark (First Application)
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Copyright Registration
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                One Consultation with Certified TAX Expert
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                All government fees are included with this package
                            </span>
                        </div>
                    </p>

                    <p className="color-text fs-5 mb-4">
                        <b>In the Basic Package, You will Get: 1,29,999 TK</b><br />
                        <b className='px-5'>*EMI Facilities</b>
                    </p>
                    <p>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Business Consultation
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Document Preparation
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Limited Company Registration (1 Core Authorized Capital)
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Company TIN Registration
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Trade License (Up to 50 Lac Paid-up)
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Bank Account Opening Assistance
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Company Stamp
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                BIN Registration
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Trademark (First Application)
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Copyright Registration
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                One Consultation with Certified TAX Expert
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Domain & Hosting (1 Year)
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Company Portfolio Website
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Company Logo
                            </span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                Social Media Setup (Digital Marketing)
                            </span>
                        </div><div className="d-flex align-items-center mb-2">
                            <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                            <span>
                                All government fees are included with this package
                            </span>
                        </div>
                        <div style={{ color: 'red' }}>
                            **These packages only applicable for Bangladeshi resident’s, not applicable for foreign clients.
                        </div>
                    </p>
                </div>
            </div>

            <div className='container-xxl center-background1'>
                <h2> Related Articles</h2>
            </div>

            <div className='container-xxl center-background1'>
                <Marquee className="marquee-container">
                    <MarqueeCard
                        imageUrl={uddoktaImg}
                        title="Startup Packages"
                        buttonText="Read More"
                        buttonLink="/startup-packages"
                    />
                    <MarqueeCard
                        imageUrl={projectImg}
                        title="Project Profile"
                        buttonText="Read More"
                        buttonLink="/project-profile"
                    />
                    <MarqueeCard
                        imageUrl={tradeImg}
                        title="Trade License"
                        buttonText="Read More"
                        buttonLink="/trade-license"
                    />
                    <MarqueeCard
                        imageUrl={exportImg}
                        title="Export License"
                        buttonText="Read More"
                        buttonLink="/export-license"
                    />
                    <MarqueeCard
                        imageUrl={imprortImg}
                        title="Import License"
                        buttonText="Read More"
                        buttonLink="/import-license"
                    />
                    <MarqueeCard
                        imageUrl={loanImg}
                        title="Loan Consultancy"
                        buttonText="Read More"
                        buttonLink="/loan-consultancy"
                    />
                    <MarqueeCard
                        imageUrl={rjscImg}
                        title="RJSC Return Filling"
                        buttonText="Read More"
                        buttonLink="/rjsc-return-filing"
                    />
                    <MarqueeCard
                        imageUrl={partnershipImg}
                        title="Partnership Registration"
                        buttonText="Read More"
                        buttonLink="/partnership-registration"
                    />
                    <MarqueeCard
                        imageUrl={societyRegistrationIMg}
                        title="Society Registration"
                        buttonText="Read More"
                        buttonLink="/society-registration"
                    />
                    <MarqueeCard
                        imageUrl={onePersionCompanyImg}
                        title="One Permission Company"
                        buttonText="Read More"
                        buttonLink="/one-person-company"
                    />
                    <MarqueeCard
                        imageUrl={compnayFormationImg}
                        title="Company Formation"
                        buttonText="Read More"
                        buttonLink="/company-formation"
                    />
                    <MarqueeCard
                        imageUrl={BSTIPermissionImg}
                        title="BSTI Permission"
                        buttonText="Read More"
                        buttonLink="/btcl-domain-registration"
                    />

                </Marquee>
            </div>

            <div className="container py-5 my-0">
                <h2 className="color-text text-center mb-4">Uddokta Package FAQ</h2>
                <Faq items={faqItems} />
            </div>
            <Footer />
        </>
    )
}

export default UddoktaPackage